<template>
  <div class="form-group" v-if="fbinvisible != 'true'">
    <!-- <div :class="wrapperclass"> -->
    <div class="row" :style="fblabelposition == 'right'? 'flex-direction: row-reverse;': ''">
      <div
        class="col-form-label"
        :class="fblabelposition == 'top' ? 'col-sm-12' : fblabelposition == 'center' ? 'col-sm-12 text-center' : fblabelposition == null|| undefined || '' ? 'col-sm-12' :'col-sm-2'"
        v-if="fbhidelabel !== 'true'"
      >
        <label><b style="color: red;" v-if="fbrequired == 'true'">*</b> {{fbsupportmultiplelanguages? $helper.getWord(fblabel) :fblabel || '&nbsp;' }}</label>
      </div>
      <!-- <div :class="inputclass + 'col-sm-12'" > -->
      <div
        class="col-form-input"
        :class="fblabelposition == 'top'? 'col-sm-12' : fblabelposition == 'center' ? 'col-sm-12' : (fblabelposition == null || undefined || '')? 'col-sm-12' : 'col-sm-10'"
      >
        <input
          :value="value"
          :id="id"
          v-bind:class="className"
          type="text"
          ref="input"
          class="form-control datepicker"
          :required="fbrequired == 'true' ? true : false"
          autocomplete="off"
          :readonly="checkReadonly(isedit, fbreadonly)"
        />
      </div>
      <span v-if="fbhelptext" class="form-text text-muted">{{ fbhelptext }}</span>

      <!-- </div> -->
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: "DateBox",
  props: [
    "id",
    "fblabel",
    "fbsupportmultiplelanguages",
    "fbplaceholder",
    "labelwidth",
    "value",
    "fbvalue",
    "fbrequired",
    "fbreadonly",
    "minDate",
    "maxDate",
    "fbhidelabel",
    "fblabelposition",
    "fbhelptext",
    "className",
    "wrapperclass",
    "labelclass",
    "inputclass",
    "isedit",
    "fbtype",
    "fbinvisible",
    "fbtypedetail"
  ],
  computed: {
    tracker() {
      return this.$store.getters.getChangeTracker;
    },
    labelCol() {
      return this.labelwidth || 12;
    }
  },

  data() {
    return {
      // date: "",
      inited: false,
      isValid: true,
      val: null,
      choose: false
    };
  },
  methods: {
    initDatepicker() {
      let $vm = this;

      setTimeout(function() {
        if ($vm.isedit) {
          if ($vm.fbreadonly == "true") {
            if ($($vm.$refs.input).data("daterangepicker")) {
              $($vm.$refs.input).data("daterangepicker").remove();
            }
          } else {
            if ($($vm.$refs.input).data("daterangepicker")) {
              $($vm.$refs.input).data("daterangepicker").remove();
            }
            if (jQuery().daterangepicker) {
              if ($($vm.$refs.input).length) {
                var self = this;

                let options = {
                  singleDatePicker: true,
                  showDropdowns: true,
                  minYear: 1,
                  locale: { format: "DD/MM/YYYY" }
                };

                if ($vm.fbtype == "pastToNow") {
                  options.maxDate = moment().format("DD/MM/YYYY");
                }else if ($vm.fbtype == 'nowToFuture'){
                  options.minDate = moment().format("DD/MM/YYYY");
                }else if ($vm.fbtype == "startFromDate"){
                  var changing = $vm.fbtypedetail.split(',')[1].slice(1,-2);
                  var changing_table = changing.split('.')[0];
                  var changing_column = changing.split('.')[1];

                  var data = $vm.$parent.formData[changing_table][changing_column];
                  options.minDate = data;
                }
                
                if($vm.minDate){
                  options.minDate = $vm.minDate;
                }

                $($vm.$refs.input).daterangepicker(options).on('close.daterangepicker', function(){
                  $vm.initDatepicker();
                });
              }

              $vm.$nextTick((e) => {
                
                $($vm.$refs.input).on("input", () => {
                  $vm.$emit("input",moment.utc($($vm.$refs.input).val(),["DD/MM/YYYY",'YYYY-MM-DD']).format("DD/MM/YYYY"));
                });

                $($vm.$refs.input).on("change", () => {
                  $vm.$emit("input",moment.utc($($vm.$refs.input).val(),["DD/MM/YYYY", "YYYY-MM-DD"]).format("DD/MM/YYYY"));
                });
              });
            }
          }
        } else {
          if ($($vm.$refs.input).data("daterangepicker")) {
            $($vm.$refs.input).data("daterangepicker").remove();
          }
        }
      }, 250);
    },
    checkReadonly(isedit, fbreadonly) {
      let readonly = true;
      if (isedit) {
        if (fbreadonly == "true") {
          readonly = true;
        } else {
          readonly = false;
        }
      } else {
        readonly = true;
      }
      return readonly;
    }
  },
  mounted() {

    let $vm = this;
    if (this.fbvalue != null) {
      this.$emit("input", moment.utc(this.fbvalue,["DD/MM/YYYY", "YYYY-MM-DD"]).format("DD/MM/YYYY"), this); //initialize the default value
    } else {
      this.$emit(
        "input",
        moment()
          .utc()
          .format("DD/MM/YYYY"),
        this
      );
    }

    if (this.value != null) {
      this.$emit("input", moment.utc(this.value,["DD/MM/YYYY", "YYYY-MM-DD"]).format("DD/MM/YYYY"), this);
    } else {
      this.$emit(
        "input",
        moment()
          .utc()
          .format("DD/MM/YYYY"),
        this
      );
    }
    this.initDatepicker();
  },
  watch: {
    isedit: function() {
      this.initDatepicker();

      if (this.value != null) {
        this.$emit("input", moment.utc(this.value,["DD/MM/YYYY", "YYYY-MM-DD"]).format("DD/MM/YYYY"), this);
      }
    },
    maxDate: function(){
      this.initDatepicker();

      if (this.value != null) {
        this.$emit("input", moment.utc(this.value,["DD/MM/YYYY", "YYYY-MM-DD"]).format("DD/MM/YYYY"), this);
      }
    },
    value: function(){
      this.initDatepicker();
    }
  }
};
</script>